import { z } from "zod";

import {
  genderEnum,
  breedEnum,
  ageTypeEnum,
  birthdayMonthEnum,
  ageModeEnum,
  catWeightUnitEnum,
  catBodyTypeEnum,
  catActivityLevelEnum,
  catFussinessEnum,
  catFoodTypeBeforeEnum,
  catBrandBeforeEnum,
  allergenEnum,
  catMedicalConditionEnum,
} from "../types/enums";
import {
  recipeSelectionSchema,
  treatItemSchema,
  defaultFalseSchema,
} from "./primitives";

export const catFormDataSchema = z.object({
  // User-entered identity fields
  name: z.string().optional(),
  gender: genderEnum.optional(),
  breed: breedEnum.optional(),
  lifeStage: ageTypeEnum.optional(),
  birthdayMonth: birthdayMonthEnum.optional(),
  birthday: z.string().optional(),
  isNeutered: z.boolean().optional(),

  age: z
    .object({
      years: z.number().optional(),
      months: z.number().optional(),
      weeks: z.number().optional(),
      mode: ageModeEnum.optional(),
    })
    .optional(),

  weight: z
    .object({
      valueInKg: z.number().optional(),
      valueInLb: z.number().optional(),
      unit: catWeightUnitEnum.default("KG"),
      hasUserEditedValue: defaultFalseSchema,
    })
    .optional(),

  body: z
    .object({
      bodyType: catBodyTypeEnum.optional(),
      activityLevel: catActivityLevelEnum.optional(),
    })
    .optional(),

  diet: z
    .object({
      eatingHabits: catFussinessEnum.optional(),
      current: z
        .object({
          type: z.array(catFoodTypeBeforeEnum).optional(),
          brand: catBrandBeforeEnum.optional(),
        })
        .optional(),
      foodAllergies: z
        .object({
          hasAllergies: z.boolean().optional(),
          allergens: z.array(allergenEnum).optional(),
        })
        .optional(),
    })
    .optional(),

  medical: z
    .object({
      hasConditions: z.boolean().optional(),
      conditions: z.array(catMedicalConditionEnum).optional(),
    })
    .optional(),

  // Structural fields
  softDelete: defaultFalseSchema,

  // Computed / API-derived fields
  trialPricePerDay: z.string().optional(),
  ongoingPricePerDay: z.string().optional(),
  calculatedCalories: z.number().optional(),

  // User selections
  selectedRecipes: recipeSelectionSchema.optional(),
  freeGiftTreat: treatItemSchema.optional(),
});

export type TCatFormData = z.infer<typeof catFormDataSchema>;
export type TCatFormDataInput = z.input<typeof catFormDataSchema>;
export type TCatEntry = { id: string; cat: Partial<TCatFormDataInput> };
